// tp-featured-nav.js — setas prev/next sobrepostas na imagem destacada do PDP.
// A imagem destacada é o primeiro <li class="product__media-item--featured"> do
// product-media-gallery.liquid. As setas trocam o `src` (e limpam `srcset`) do
// <img> dentro desse <li>, ciclando pelas imagens em
// `<script data-tp-featured-data>` adjacente.

(function () {
  function initFeaturedNav(scope) {
    var root = scope || document;
    var items = root.querySelectorAll(".product__media-item--featured");

    items.forEach(function (item) {
      if (item._tpFeaturedNavInit) return;

      var dataEl = item.querySelector("[data-tp-featured-data]");
      var prevBtn = item.querySelector('[data-tp-featured-nav="prev"]');
      var nextBtn = item.querySelector('[data-tp-featured-nav="next"]');
      var img = item.querySelector("img");
      // Botão interno do modal-opener — guarda o data-media-id que o
      // product-modal usa pra decidir qual mídia exibir no zoom.
      var modalToggleBtn = item.querySelector(".product__media-toggle");

      if (!dataEl || !prevBtn || !nextBtn || !img) return;

      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var images = (data && data.images) || [];
      if (images.length < 2) return;

      item._tpFeaturedNavInit = true;

      // Localiza o índice inicial pelo src atual (fallback: 0)
      var initialSrc = img.getAttribute("src") || "";
      var currentIndex = images.findIndex(function (entry) {
        return entry.src && initialSrc.indexOf(entry.src.split("?")[0]) !== -1;
      });
      if (currentIndex < 0) currentIndex = 0;

      function show(index) {
        var entry = images[(index + images.length) % images.length];
        if (!entry) return;
        img.setAttribute("src", entry.src);
        img.removeAttribute("srcset");
        if (entry.alt) img.setAttribute("alt", entry.alt);
        // Sincroniza o data-media-id do botão do modal pra que o zoom
        // abra na imagem atualmente exibida (e não na primeira).
        if (modalToggleBtn && entry.id != null) {
          modalToggleBtn.setAttribute("data-media-id", entry.id);
        }
        currentIndex = (index + images.length) % images.length;
      }

      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(currentIndex - 1);
      });

      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(currentIndex + 1);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initFeaturedNav();
    });
  } else {
    initFeaturedNav();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initFeaturedNav(e.target);
  });
})();
